<template src="./ModalStoreWarehouseListComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed, onMounted} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {ErrorText} from "@/supports/error-message.constant.js";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {AppConstant} from "@/supports/app.constant.js";
import {useRouter} from "vue-router";
import {useAccountStore} from "@/stores/account.js";
import {useStore} from "@/stores/store.js";


export default {
  name: 'ModalStoreWarehouseListComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModalStoreWarehouse: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    typeSelectItem: {
      type: String,
      required: false,
      default: () => 'multiple'
    },
    listStoreWarehousesSelected: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['showModalStoreWarehouse', 'listStoreWarehousesSelectedCurrent'],
  setup(props, { emit }) {
    const labelButtonSubmit = ref('Xác Nhận')
    const dataSelect = ref({
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      warehouse_id: {
        id: 'warehouse_id',
        label: 'Kho hàng',
        placeholder: 'Kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
    })
    const errors = ref(true)
    const listStoreWarehouseCurrent = ref([])
    const listChecked = ref({})
    const listStoreWarehousesSelectedCurrent = ref([])
    const warehouseStore = useWarehouseStore()
    const clickShowModal = ref(false)
    const router = useRouter()
    const accountStore = useAccountStore()
    const storeCompStore = useStore()

    watch(() => warehouseStore.warehouses, (newListWarehouse) => {
      listStoreWarehouseCurrent.value = newListWarehouse
    });

    watch(() => props.listStoreWarehousesSelected, (newListStoreWarehouseSelected) => {
      listChecked.value = [];
      listStoreWarehousesSelectedCurrent.value = [];
      newListStoreWarehouseSelected.forEach((item) => {
        listChecked.value[item.id] = true
        listStoreWarehousesSelectedCurrent.value.push(item.id)
      })
    });


    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      clickShowModal.value = eventClickShowModal
      if(clickShowModal.value && (warehouseStore.warehouses.length === 0 || (warehouseStore.warehouses.length > 0 && warehouseStore.lastPage !== 1)) ) {
        emit('showModalStoreWarehouse', true)
      }
      if(warehouseStore.warehouses.length > 0 && warehouseStore.lastPage === 1) {
        listChecked.value = [];
        listStoreWarehousesSelectedCurrent.value.forEach((id) => {
          listChecked.value[id] = true
        })
        emit('showModalStoreWarehouse', true)
      }
    })

    function validateForm(value, name) {
    
      if(name === 'warehouse_id') {
        dataSelect.value.warehouse_id.isError = false;
        dataSelect.value.warehouse_id.error = ''
        errors.value = false
        if(!value) {
          dataSelect.value.warehouse_id.isError = true;
          dataSelect.value.warehouse_id.error = ErrorText.REQUIRED(dataSelect.value.warehouse_id.label);
          errors.value = true
        }
      }
      if(name === 'store_id') {
        dataSelect.value.store_id.isError = false;
        dataSelect.value.store_id.error = ''
        errors.value = false
        if(!value) {
          dataSelect.value.store_id.isError = true;
          dataSelect.value.store_id.error = ErrorText.REQUIRED(dataSelect.value.store_id.label);
          errors.value = true
        }
      }
    }

    onMounted(() => {
      getListStores();
      getListWarehouses();
    })

    watch(() => storeCompStore.stores, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          dataSelect.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
    });

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    async function getListWarehouses() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/list-warehouse';
      await warehouseStore.getListWarehouses(url, params);
      warehouseStore.warehouses.forEach((warehouse) => {
        dataSelect.value.warehouse_id.options.push({
          name: warehouse.name,
          value: warehouse.id
        })
      })
    }

    function onChange(value, name) {
      dataSelect.value[name].value = value
    }

    function applyStoreWarehouseSelected() {
      emit('listStoreWarehousesSelectedCurrent', {
         store_id: dataSelect.value.store_id.value,
          warehouse_id: dataSelect.value.warehouse_id.value
      })

      emit('showModalWarehouse', false)
    }
    return {
      CommonService,
      dataSelect,
      validateForm,
      errors,
      labelButtonSubmit,
      onChange,
      applyStoreWarehouseSelected
    }
  },
}
</script>
<style lang="scss">
#modaldeliverywarehouse {
  .modal-content {
    background: #ffffff;
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
